<template>
  <Pull :onPull="pull" ref="pull">
    <div class="con">
      <div v-if="list.length > 0">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="c-item" @click="detail(item.id)">
            <div class="tilte-time">
              <span class="title">{{ item.attributionName }}</span>
              <span class="time">{{ timeFormatDate(item.dates) }}</span>
            </div>
            <div class="c-main">
              <div>单号：{{ item.name }}</div>
              <div>类型：{{ item.billTypeName }}</div>
              <div>金额：{{ item.drawAmount }} 元</div>
            </div>
          </div>
          <div class="remove" @click="remove(item.id)">删除</div>
        </div>
      </div>
      <div class="no-data" v-else>
        <img src="@/assets/propertyImg/no-data.png" alt="" />
        <span>暂无数据</span>
      </div>
    </div>
  </Pull>
</template>
<script>
import { timeFormatDate } from '@/utils';
import { getDrawDraftsList, getDrawDeleteDraft } from '@/axios/drafts';
import Pull from '@/commonComponents/PullRefresh';
import { Toast, Dialog } from 'vant';
export default {
  components: {
    Pull,
  },
  data() {
    return {
      list: [],
      pageInfo: {
        size: 10,
        current: 1,
      },
      isData: true,
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    timeFormatDate,
    pull(num) {
      // 上拉刷新
      this.gainMore();
    },
    gainMore() {
      // 加载更多数据列表
      this.pageInfo.current += 1;
      this.getData();
    },
    async getData() {
      //   let parms = {
      //     ...this.pageInfo,
      //   };
      const res = await getDrawDraftsList(this.pageInfo.size, this.pageInfo.current);
      let responseData = res.data.data.records;
      if (responseData.length == 0) {
        this.$refs.pull.$emit('loadOver'); // 加载完毕，无数据了
        this.isData = false;
      } else {
        this.$refs.pull.$emit('loadEnd'); // 加载完毕，可能还有下一波数据
        for (let i = 0; i < responseData.length; i++) {
          this.list.push(responseData[i]);
        }
        this.isData = true;
      }
    },
    //删除
    remove(getId) {
      Dialog.confirm({
        title: '删除',
        message: '确认要删除吗',
      })
        .then(async () => {
          const res = await getDrawDeleteDraft(getId);
          if (res.data.msg == 'SUCCESS') {
            Toast.success('删除成功');
            this.list = [];
            this.getData();
          } else {
            Toast.fail('删除失败');
          }
        })
        .catch(() => {});
    },
    //跳转到详情
    detail(getId) {
      this.$router.push({
        path: '/bills',
        query: {
          type: 5,
          id: getId,
        },
      });
    },
    backPage() {
      // 回退到app
      window.location.href = 'jsToOc://back';
    },
  },
};
</script>
<style scoped>
.con {
  margin: 0px 10px 25px 10px;
}
.item {
  background: #fff;
  margin: 15px 0px 10px 0px;
  border-radius: 8px;
}
.item .c-item {
  padding: 0px 15px;
}
.tilte-time {
  position: relative;
  display: flex;
  line-height: 80%;
  line-height: 45px;
}
.tilte-time .title {
  font-size: 14px;
  color: #333;
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tilte-time .time {
  position: absolute;
  right: -5px;
  font-size: 12px;
  color: #999;
  text-align: center;
}
.c-main {
  font-size: 13px;
  color: #666;
  line-height: 22px;
}
.remove {
  line-height: 40px;
  color: #666;
  text-align: center;
  border-top: solid 1px #e8e8e8;
  margin-top: 10px;
  font-size: 14px;
}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.3rem;
}
.no-data img {
  width: 5rem;
  height: 5rem;
  margin-bottom: 0.5rem;
}
.no-data span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  font-size: 28rpx !important;
}
</style>
